import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";

type PanelToggleProps = {
  side: "left" | "right";
  open: boolean;
  onToggle: () => void;
};

export function PanelToggle({ side, open, onToggle }: PanelToggleProps) {
  const { t } = useTranslation();
  const left = side === "left";
  const label = left
    ? t(open ? "editor.hideInput" : "editor.showInput")
    : t(open ? "editor.hidePanel" : "editor.showPanel");
  const Icon = left === open ? ChevronLeft : ChevronRight;

  return (
    <Button
      variant="outline"
      size="icon-sm"
      className={`absolute top-16 z-10 h-12 w-6 rounded-full border-neutral-200 bg-white text-neutral-500 shadow-none hover:border-neutral-400 hover:text-neutral-900 ${left ? "-left-3" : "-right-3"}`}
      aria-label={label}
      title={label}
      aria-expanded={open}
      aria-controls={left ? "schedule-input-panel" : "editor-panel"}
      onClick={onToggle}
    >
      <Icon aria-hidden="true" />
    </Button>
  );
}
